<template>
  <v-app light>
    <v-toolbar fixed app >
      <!--
      <v-toolbar-side-icon @click.stop="drawer = !drawer" light></v-toolbar-side-icon>
      -->

      <v-btn id="logo" flat to="/" class="toolbar__title">ACTIVE HOOP</v-btn>

      <v-spacer></v-spacer>

   <v-btn icon dark to="/schedule">
      <v-icon icon >date_range</v-icon>
    </v-btn>

    <v-btn icon dark to="/tournament">
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn dark v-if = "user" icon to="/user/profile">
      <v-icon>person</v-icon>
    </v-btn>


    <v-btn dark v-if = "user==null" icon to="/auth">
      ログイン
    </v-btn>

    </v-toolbar>

    <main>
      <v-content>
      <v-container fluid class="ah-container">
          <router-view></router-view>
      </v-container>
      </v-content>
    </main>

    <v-footer class="pa-3" style="font-size:12px">
      <div>Copyright © {{ new Date().getFullYear() }} ACTIVE HOOP All rights reserved.</div>
    </v-footer>
    <v-footer class="pa-3 mt-0">
      <router-link class="ah-footer-legal-link" to="/privacypolicy">プライバシーポリシー</router-link>
      <router-link class="ah-footer-legal-link" to="/terms">利用規約</router-link>
      <router-link class="ah-footer-legal-link" to="/managementgroup">運営団体</router-link>
    </v-footer>
  </v-app>
</template>



<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { icon: 'bubble_chart', title: 'サインイン', href: '/#/signin' },
        { icon: 'bubble_chart', title: 'Inspireaaaa', href: '/#/test' },
        { icon: 'bubble_chart', title: '大会情報', href: '/#/tournament' },
        { icon: 'bubble_chart', title: 'Inspire2', href: '/' }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'ACTIVE HOOP'
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>

<style lang="stylus">
  @import './stylus/main'

  #logo div { color: #fff; background: rgba(0,0,0,0.87);}
  .toolbar__content {background: rgba(0,0,0,0.87);}

.ah-footer-legal-link {
    font-size: 11px;
    font-weight: 400;
    color: #555;
    text-decoration: none;
    border-right: 1px solid #d6d6d6;
    margin-right: 10px;
    padding-right: 12px;
    display: inline-block;
    margin-top: 3px;
    white-space: nowrap;
}
.ah-container {
  padding:0px;
}

.ah-tournament-card {text-align: left;margin-top: 25px;}
.ah-tournament-card span {display: block;}
.ah-tournament-card .title {
    display: block;
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 23px;}
.ah-tournament-card .sub-title {
    display: block;
    font-weight: 300;
    font-size: 16px;}

  .ah-tournament-finished-card {text-align: left;margin-top: 0px;}
  .ah-tournament-finished-card span {display: block;}
  .ah-tournament-finished-card .title {
    display: block;
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 23px;}
  .ah-tournament-finished-card .sub-title {
    display: block;
    font-weight: 300;
    font-size: 16px;}

.colorfilter-R30 {background-color:#720080;}
.colorfilter-R30 .card__media__background {opacity:0.4;}

.colorfilter-C2 {background-color:#320080;}
.colorfilter-C2 .card__media__background {opacity:0.4;}

.colorfilter-C3 {background-color:#024a18;}
.colorfilter-C3 .card__media__background {opacity:0.4;}

.colorfilter-U180 {background-color:#022c4f;}
.colorfilter-U180 .card__media__background {opacity:0.4;}

</style>



// WEBPACK FOOTER //
// src/App.vue